function PrivacyPolicyPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-2xl md:text-3xl font-bold text-center">MossAura 隐私政策</h1>
      <div className="mt-2 space-y-1 text-center text-sm text-gray-400">
        <p>版本号：V20260806</p>
        <p>发布日期：2026 年 8 月 6 日</p>
        <p>生效日期：2026 年 8 月 6 日</p>
      </div>

      <section className="mt-10">
        <h2 className="text-lg font-semibold">引言</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          新译信息科技（深圳）有限公司（MossAura 应用的运营方和个人信息处理者，以下简称"我们"）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">请您在使用 MossAura 前，仔细阅读并充分理解本政策，特别是以粗体标识的条款。</strong>
        </p>

        <h3 className="mt-6 text-base font-semibold">特别提示</h3>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li><strong className="font-semibold">MossAura 的核心功能是录音、语音转写与 AI 内容总结。使用该功能时，我们会收集您通过手机麦克风或 MossAura 蓝牙设备录制的录音音频，并将其上传至我们的服务器进行语音转写和 AI 总结处理。</strong></li>
          <li><strong className="font-semibold">若您主动使用"声纹识别/说话人标记"功能，我们会处理您或录音中他人的声纹特征信息。声纹属于生物识别信息，是敏感个人信息，我们仅在您单独同意后处理。</strong></li>
          <li><strong className="font-semibold">我们及我们集成的第三方 SDK 会涉及剪贴板信息的写入与读取，详见"第一部分 第 8 条 剪贴板信息"。</strong></li>
          <li><strong className="font-semibold">在您首次启动并同意本政策之前，我们不会初始化任何收集设备标识信息的第三方 SDK（包括友盟+ 与腾讯 Bugly），也不会读取 Android_ID、OAID 等设备标识符。</strong></li>
          <li><strong className="font-semibold">若您在录音中涉及他人的声音、姓名或个人信息，请您确保已取得该等第三方的合法授权。</strong></li>
        </ul>
        <p className="mt-3 leading-7 text-sm md:text-base">
          如您对本政策有任何疑问、意见或建议，可通过 <strong className="font-semibold">service02@newtranx.com</strong> 与我们联系。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">第一部分　我们如何收集和使用您的个人信息</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们仅会出于本政策所述目的，收集和使用您的个人信息。<strong className="font-semibold">若某项个人信息为非必要信息，您拒绝提供不影响您使用其他功能。</strong>
        </p>

        <h3 className="mt-6 text-base font-semibold">1. 注册、登录与账号管理</h3>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full border-collapse text-sm md:text-base">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">场景</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">收集的个人信息</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">是否必要</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">目的</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-200 px-3 py-2">手机号注册/登录</td>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">手机号码</strong>、短信验证码</td>
                <td className="border border-gray-200 px-3 py-2">必要</td>
                <td className="border border-gray-200 px-3 py-2">创建账号、身份验证</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">邮箱注册/登录</td>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">电子邮箱地址</strong>、账号密码（加密存储）</td>
                <td className="border border-gray-200 px-3 py-2">必要</td>
                <td className="border border-gray-200 px-3 py-2">创建账号、身份验证、密码找回</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">完善个人资料</td>
                <td className="border border-gray-200 px-3 py-2">昵称、头像图片、语言与时区偏好</td>
                <td className="border border-gray-200 px-3 py-2">非必要</td>
                <td className="border border-gray-200 px-3 py-2">个性化展示</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">若您不注册登录，将无法使用录音上传、云端转写、AI 总结与多设备同步等核心功能。</strong>
        </p>

        <h3 className="mt-6 text-base font-semibold">2. 录音、语音转写与 AI 总结（核心功能）</h3>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full border-collapse text-sm md:text-base">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">收集的个人信息</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">收集方式</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">目的</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">录音音频文件</strong></td>
                <td className="border border-gray-200 px-3 py-2">经您授权后，通过手机麦克风或已配对的 MossAura 蓝牙设备采集；或由您主动从本机导入音频文件</td>
                <td className="border border-gray-200 px-3 py-2">生成语音转写文稿</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">语音转写文稿</strong></td>
                <td className="border border-gray-200 px-3 py-2">由录音音频经语音识别生成</td>
                <td className="border border-gray-200 px-3 py-2">向您展示转写内容、供您编辑</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">AI 摘要、待办事项、决策要点、会议纪要</strong></td>
                <td className="border border-gray-200 px-3 py-2">由转写文稿经 AI 模型生成</td>
                <td className="border border-gray-200 px-3 py-2">向您提供内容总结服务</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">录音的时长、创建时间、标题、标签、备注</td>
                <td className="border border-gray-200 px-3 py-2">录音过程与您的编辑操作</td>
                <td className="border border-gray-200 px-3 py-2">组织与检索您的记录</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">上述音频与文本内容会上传至我们的服务器进行处理，并在云端保存，以便您在更换或多台设备上访问。您可随时在应用内删除单条记录或全部记录。</strong>
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们不会将您的录音音频、转写文稿或 AI 总结内容用于广告投放，也不会将其提供给第三方用于与本政策无关的目的。
        </p>

        <h3 className="mt-6 text-base font-semibold">3. 声纹与说话人识别（敏感个人信息 · 单独同意）</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">当您主动使用"声纹注册/说话人标记"功能时，我们会从您指定的录音片段中提取声纹特征信息，用于在后续录音中自动区分和标记说话人。</strong>
        </p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li><strong className="font-semibold">声纹信息属于《个人信息保护法》定义的生物识别信息，为敏感个人信息。我们仅在获得您的单独同意后处理。</strong></li>
          <li>处理目的仅限于说话人区分与标记，<strong className="font-semibold">不用于身份认证、支付、广告或任何其他用途</strong>。</li>
          <li>该功能为可选功能，<strong className="font-semibold">您拒绝授权不影响录音、转写与总结等核心功能的使用</strong>。</li>
          <li>您可随时在应用内删除已注册的声纹，删除后我们将同步删除服务器上对应的声纹特征数据。</li>
        </ul>

        <h3 className="mt-6 text-base font-semibold">4. 人物档案（应用内联系人）</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          您可在应用内自行创建"人物"条目，填写姓名、备注、头像颜色等信息，用于标记录音中的说话人。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">该功能不会读取您手机系统的通讯录。MossAura 未申请也未使用读取通讯录权限，所有人物信息均由您手动录入。</strong>
        </p>

        <h3 className="mt-6 text-base font-semibold">5. 蓝牙设备连接与管理</h3>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full border-collapse text-sm md:text-base">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">收集的信息</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">目的</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-200 px-3 py-2">附近蓝牙设备的名称、MAC 地址、信号强度</td>
                <td className="border border-gray-200 px-3 py-2">搜索并连接 MossAura 蓝牙录音设备</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">已连接设备的型号、固件版本、电量、序列号</td>
                <td className="border border-gray-200 px-3 py-2">展示设备状态、进行固件升级与故障诊断</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">关于位置权限的重要说明：Android 操作系统规定，应用进行蓝牙扫描时必须同时申请位置权限。我们申请该权限仅为满足系统的蓝牙扫描要求，MossAura 不会收集、不会上传您的 GPS 或 Wi-Fi 地理位置信息，应用中也未集成任何定位 SDK。</strong>
        </p>

        <h3 className="mt-6 text-base font-semibold">6. 消息推送与通知</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          为向您推送录音处理完成提醒、设备状态提醒及服务通知，我们（通过友盟+ U-Push SDK）会收集设备推送标识（Push Token）、设备型号与系统版本。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          您可在系统设置中关闭通知权限，关闭后将无法收到推送消息，但不影响其他功能。
        </p>

        <h3 className="mt-6 text-base font-semibold">7. 意见反馈与客户服务</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          当您通过"意见反馈"或"功能建议"提交内容时，我们会收集您填写的问题描述、联系方式（选填），以及您<strong className="font-semibold">主动从相册中选择上传</strong>的截图。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">该功能使用系统相册选择器，我们仅能获取您明确选中的图片，无法访问您相册中的其他内容。MossAura 未申请拍照权限。</strong>
        </p>

        <h3 className="mt-6 text-base font-semibold">8. 剪贴板信息</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">我们在以下两类场景中涉及剪贴板信息，特此向您明确告知：</strong>
        </p>

        <h4 className="mt-5 text-sm font-semibold">8.1 应用自身对剪贴板的写入（不读取）</h4>
        <p className="mt-3 leading-7 text-sm md:text-base">
          当您主动点击应用内的"复制"按钮时，我们会将您选中的内容写入系统剪贴板，便于您粘贴到其他应用。涉及的内容包括：转写文稿、AI 摘要、待办与决策事项、分享链接、账号邮箱地址，以及开发者调试页面中的诊断信息。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">该写入行为仅在您主动点击"复制"时发生。MossAura 应用自身不会读取您剪贴板中的任何内容，写入剪贴板的内容也不会被上传至我们的服务器。</strong>
        </p>

        <h4 className="mt-5 text-sm font-semibold">8.2 第三方 SDK 对剪贴板的读取</h4>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">我们集成的友盟+ 基础组件 SDK（由友盟同欣信息科技（北京）有限公司提供）在实现其统计分析与分享回流功能的过程中，可能读取您设备剪贴板中的信息，用于识别推广渠道来源、分享口令与安装归因。</strong>
        </p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li><strong className="font-semibold">该 SDK 仅在您同意本隐私政策后才会被初始化；在您同意前，我们不会初始化该 SDK，因而不存在任何剪贴板读取行为。</strong></li>
          <li>我们不会主动获取剪贴板中的内容，也不会将剪贴板内容用于用户画像、精准营销或广告推送。</li>
          <li>该 SDK 的具体信息与其隐私政策链接，见"第三部分 第三方 SDK 清单"。</li>
          <li><strong className="font-semibold">您可在手机系统设置中限制 MossAura 的剪贴板访问权限（部分 Android 系统提供"剪贴板读取提醒/禁止"设置），或在您撤回对本政策的同意后停止该 SDK 的运行。</strong></li>
        </ul>

        <h3 className="mt-6 text-base font-semibold">9. 设备信息、日志信息与安全保障</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          为保障账号与服务安全、识别异常设备、进行机型适配与故障分析，在您同意本政策后，我们会收集：
        </p>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full border-collapse text-sm md:text-base">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">信息类别</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">具体字段</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">目的</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-200 px-3 py-2">设备标识</td>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">Android_ID、OAID（匿名设备标识符）</strong></td>
                <td className="border border-gray-200 px-3 py-2">设备识别、安全风控、统计去重</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">设备信息</td>
                <td className="border border-gray-200 px-3 py-2">设备品牌、型号、操作系统版本、系统语言、时区、屏幕参数、SIM 卡所属国家/地区代码</td>
                <td className="border border-gray-200 px-3 py-2">机型适配、语言与地区适配、故障分析</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">网络信息</td>
                <td className="border border-gray-200 px-3 py-2">IP 地址、网络连接类型（Wi-Fi/移动网络）、运营商信息</td>
                <td className="border border-gray-200 px-3 py-2">网络诊断、安全风控</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">应用信息</td>
                <td className="border border-gray-200 px-3 py-2">应用版本号、渠道标识、安装与启动时间</td>
                <td className="border border-gray-200 px-3 py-2">版本适配、崩溃归因</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">日志信息</td>
                <td className="border border-gray-200 px-3 py-2">崩溃堆栈、异常日志、关键操作诊断日志、服务访问记录</td>
                <td className="border border-gray-200 px-3 py-2">排查故障、改进服务质量</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">我们不会读取您的 IMEI、MAC 地址、应用安装列表或短信内容。</strong>
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">在您同意本政策之前，我们不会读取 Android_ID 或 OAID，也不会初始化上述任何统计、推送、崩溃上报 SDK。</strong>
        </p>

        <h3 className="mt-6 text-base font-semibold">10. 统计分析与服务改进</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们通过友盟+ 统计 SDK 收集应用的启动次数、页面访问、功能使用频次等汇总性数据，用于了解产品使用情况、改进功能与体验。<strong className="font-semibold">该等分析基于去标识化的汇总数据进行，不用于识别特定自然人身份。</strong>
        </p>

        <h3 className="mt-6 text-base font-semibold">11. 支付与会员服务</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          若您购买 MossAura 会员或增值服务，交易将通过应用分发平台或第三方支付渠道完成。<strong className="font-semibold">我们不会收集、存储您的银行卡号、支付密码等支付凭证信息</strong>，仅接收订单号、商品标识、支付结果与订阅有效期，用于开通与维持您的会员权益、处理退款与售后咨询。
        </p>

        <h3 className="mt-6 text-base font-semibold">12. 征得同意的例外</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          根据《个人信息保护法》第十三条等法律法规，在下列情形中，我们处理您的个人信息无需征得您的同意：
        </p>
        <ol className="mt-3 space-y-2 text-sm md:text-base list-decimal pl-5">
          <li>为订立、履行您作为一方当事人的合同所必需；</li>
          <li>为履行法定职责或者法定义务所必需；</li>
          <li>为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</li>
          <li>为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</li>
          <li>依照法律规定在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；</li>
          <li>法律、行政法规规定的其他情形。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">第二部分　设备权限调用清单</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">所有权限均在您使用对应功能时动态申请，您可以拒绝授权，也可以随时在手机系统设置中关闭已授予的权限。关闭权限仅影响该权限对应的功能，不影响其他功能的正常使用。</strong>
        </p>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full border-collapse text-sm md:text-base">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">权限</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">系统权限名</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">使用目的</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">调用时机</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">拒绝的影响</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-200 px-3 py-2">麦克风</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">RECORD_AUDIO</code></td>
                <td className="border border-gray-200 px-3 py-2">录制音频以供转写与总结</td>
                <td className="border border-gray-200 px-3 py-2">您点击"开始录音"时</td>
                <td className="border border-gray-200 px-3 py-2">无法使用手机麦克风录音</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">蓝牙扫描</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">BLUETOOTH_SCAN</code></td>
                <td className="border border-gray-200 px-3 py-2">搜索附近的 MossAura 设备</td>
                <td className="border border-gray-200 px-3 py-2">您进入设备配对页面时</td>
                <td className="border border-gray-200 px-3 py-2">无法搜索与连接 MossAura 设备</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">蓝牙连接</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">BLUETOOTH_CONNECT</code></td>
                <td className="border border-gray-200 px-3 py-2">与 MossAura 设备通信、传输录音、固件升级</td>
                <td className="border border-gray-200 px-3 py-2">您连接设备时</td>
                <td className="border border-gray-200 px-3 py-2">无法使用 MossAura 硬件设备</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">位置</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">ACCESS_FINE_LOCATION</code><br /><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">ACCESS_COARSE_LOCATION</code></td>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">仅用于满足 Android 系统对蓝牙扫描的强制要求；我们不收集、不上传地理位置信息</strong></td>
                <td className="border border-gray-200 px-3 py-2">蓝牙扫描时</td>
                <td className="border border-gray-200 px-3 py-2">部分 Android 版本上无法搜索蓝牙设备</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">附近的 Wi-Fi 设备</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">NEARBY_WIFI_DEVICES</code><br /><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">ACCESS_WIFI_STATE</code><br /><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">CHANGE_WIFI_STATE</code></td>
                <td className="border border-gray-200 px-3 py-2">设备配网与网络状态判断</td>
                <td className="border border-gray-200 px-3 py-2">设备配网、网络诊断时</td>
                <td className="border border-gray-200 px-3 py-2">配网或网络状态判断受影响</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">通知</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">POST_NOTIFICATIONS</code></td>
                <td className="border border-gray-200 px-3 py-2">展示录音处理进度、设备状态与服务通知</td>
                <td className="border border-gray-200 px-3 py-2">首次需要发送通知时</td>
                <td className="border border-gray-200 px-3 py-2">无法收到通知与推送消息</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">前台服务（麦克风）</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">FOREGROUND_SERVICE</code><br /><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">FOREGROUND_SERVICE_MICROPHONE</code></td>
                <td className="border border-gray-200 px-3 py-2">保证应用退至后台时录音不中断</td>
                <td className="border border-gray-200 px-3 py-2">录音开始时</td>
                <td className="border border-gray-200 px-3 py-2">后台录音会被系统中断</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">悬浮窗</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">SYSTEM_ALERT_WINDOW</code></td>
                <td className="border border-gray-200 px-3 py-2">在其他应用之上展示录音状态悬浮窗</td>
                <td className="border border-gray-200 px-3 py-2">您开启悬浮窗功能时</td>
                <td className="border border-gray-200 px-3 py-2">无法使用悬浮窗，不影响录音</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">后台常驻</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">WAKE_LOCK</code></td>
                <td className="border border-gray-200 px-3 py-2">录音期间保持设备唤醒，避免录音中断</td>
                <td className="border border-gray-200 px-3 py-2">录音期间</td>
                <td className="border border-gray-200 px-3 py-2">息屏后录音可能中断</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">震动</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">VIBRATE</code></td>
                <td className="border border-gray-200 px-3 py-2">操作反馈与提醒</td>
                <td className="border border-gray-200 px-3 py-2">特定交互时</td>
                <td className="border border-gray-200 px-3 py-2">无震动反馈</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">相册读取</td>
                <td className="border border-gray-200 px-3 py-2">由系统相册选择器提供，<strong className="font-semibold">不申请存储权限</strong></td>
                <td className="border border-gray-200 px-3 py-2">您上传反馈截图</td>
                <td className="border border-gray-200 px-3 py-2">您在反馈页选择图片时</td>
                <td className="border border-gray-200 px-3 py-2">无法上传反馈截图</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">日历</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">READ_CALENDAR</code><br /><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">WRITE_CALENDAR</code></td>
                <td className="border border-gray-200 px-3 py-2">为"将 AI 识别出的待办与日程写入系统日历"功能预留。<strong className="font-semibold">当前版本尚未启用该功能，我们不会读取、不会上传您的日历数据</strong>；功能正式上线时将由您主动触发并单独向您申请授权</td>
                <td className="border border-gray-200 px-3 py-2">当前版本不会调用</td>
                <td className="border border-gray-200 px-3 py-2">无影响</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">网络</td>
                <td className="border border-gray-200 px-3 py-2"><code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[0.85em] text-gray-700">INTERNET</code></td>
                <td className="border border-gray-200 px-3 py-2">上传录音、获取转写与总结结果、同步数据</td>
                <td className="border border-gray-200 px-3 py-2">使用云端功能时</td>
                <td className="border border-gray-200 px-3 py-2">无法使用任何云端功能</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">第三部分　第三方 SDK 清单</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          为实现本政策所述功能，我们接入了以下第三方 SDK。<strong className="font-semibold">第三方 SDK 收集和处理您个人信息的行为适用其自身的隐私政策，我们建议您阅读相应政策。所有涉及个人信息收集的 SDK，均仅在您同意本隐私政策后才会初始化。</strong>
        </p>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full border-collapse text-sm md:text-base">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">SDK 名称</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">提供方</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">使用目的</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">收集的个人信息类型</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">隐私政策</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">友盟+ 基础组件 SDK</strong><br />（U-App / 统计分析）</td>
                <td className="border border-gray-200 px-3 py-2">友盟同欣信息科技（北京）有限公司</td>
                <td className="border border-gray-200 px-3 py-2">应用统计分析、渠道归因、服务改进</td>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">设备标识（Android_ID、OAID）、设备型号与系统版本、网络状态、IP 地址、剪贴板信息</strong></td>
                <td className="border border-gray-200 px-3 py-2"><a className="text-blue-600 break-all hover:underline" href="https://www.umeng.com/page/policy" target="_blank" rel="noreferrer">https://www.umeng.com/page/policy</a></td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">友盟+ U-Push 推送 SDK</strong></td>
                <td className="border border-gray-200 px-3 py-2">友盟同欣信息科技（北京）有限公司</td>
                <td className="border border-gray-200 px-3 py-2">消息推送与通知送达</td>
                <td className="border border-gray-200 px-3 py-2">设备标识（Android_ID、OAID）、推送标识（Push Token）、设备型号与系统版本、网络状态</td>
                <td className="border border-gray-200 px-3 py-2"><a className="text-blue-600 break-all hover:underline" href="https://www.umeng.com/page/policy" target="_blank" rel="noreferrer">https://www.umeng.com/page/policy</a></td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">腾讯 Bugly</strong></td>
                <td className="border border-gray-200 px-3 py-2">深圳市腾讯计算机系统有限公司</td>
                <td className="border border-gray-200 px-3 py-2">崩溃与异常上报、稳定性分析</td>
                <td className="border border-gray-200 px-3 py-2">设备型号与系统版本、设备标识、崩溃堆栈与运行日志、应用版本</td>
                <td className="border border-gray-200 px-3 py-2"><a className="text-blue-600 break-all hover:underline" href="https://bugly.qq.com/v2/contract" target="_blank" rel="noreferrer">https://bugly.qq.com/v2/contract</a></td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">NvEasy BLE / NvEasy Audio SDK</strong></td>
                <td className="border border-gray-200 px-3 py-2">新译信息科技（深圳）有限公司（自研）</td>
                <td className="border border-gray-200 px-3 py-2">与 MossAura 蓝牙设备通信、音频采集与解码</td>
                <td className="border border-gray-200 px-3 py-2">蓝牙设备信息（名称、MAC 地址、固件版本、电量）；<strong className="font-semibold">音频数据仅在本地处理，不由该 SDK 上传</strong></td>
                <td className="border border-gray-200 px-3 py-2">适用本政策</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">XXPermissions</strong></td>
                <td className="border border-gray-200 px-3 py-2">开源项目（getActivity）</td>
                <td className="border border-gray-200 px-3 py-2">系统权限申请与状态判断</td>
                <td className="border border-gray-200 px-3 py-2">不收集个人信息</td>
                <td className="border border-gray-200 px-3 py-2"><a className="text-blue-600 break-all hover:underline" href="https://github.com/getActivity/XXPermissions" target="_blank" rel="noreferrer">https://github.com/getActivity/XXPermissions</a></td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">OkHttp</strong></td>
                <td className="border border-gray-200 px-3 py-2">Square 开源项目（Block, Inc.）</td>
                <td className="border border-gray-200 px-3 py-2">网络请求</td>
                <td className="border border-gray-200 px-3 py-2">不额外收集个人信息</td>
                <td className="border border-gray-200 px-3 py-2"><a className="text-blue-600 break-all hover:underline" href="https://squareup.com/us/en/legal/general/privacy" target="_blank" rel="noreferrer">https://squareup.com/us/en/legal/general/privacy</a></td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">Google Play 服务基础库</strong><br />（play-services-base）</td>
                <td className="border border-gray-200 px-3 py-2">Google LLC</td>
                <td className="border border-gray-200 px-3 py-2">仅用于检测设备上 Google 服务的可用性以做兼容降级</td>
                <td className="border border-gray-200 px-3 py-2">不收集个人信息</td>
                <td className="border border-gray-200 px-3 py-2"><a className="text-blue-600 break-all hover:underline" href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">https://policies.google.com/privacy</a></td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">Flutter 及其官方插件</strong><br />（device_info_plus、connectivity_plus、permission_handler、shared_preferences 等）</td>
                <td className="border border-gray-200 px-3 py-2">Google LLC / Flutter 社区（开源）</td>
                <td className="border border-gray-200 px-3 py-2">读取设备与网络基础信息、权限申请、本地数据存储</td>
                <td className="border border-gray-200 px-3 py-2">设备型号、系统版本、网络状态；<strong className="font-semibold">均在本地处理，不由插件上传</strong></td>
                <td className="border border-gray-200 px-3 py-2"><a className="text-blue-600 break-all hover:underline" href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">https://policies.google.com/privacy</a></td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">中国大陆版本 MossAura 未集成 Firebase（Analytics / Crashlytics / Messaging / Auth）与 Google 登录 SDK，相关组件已在构建时物理排除。</strong>
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">第四部分　我们如何共享、转让、公开披露您的个人信息</h2>

        <h3 className="mt-6 text-base font-semibold">1. 共享</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
        <ol className="mt-3 space-y-2 text-sm md:text-base list-decimal pl-5">
          <li><strong className="font-semibold">在获取明确同意的情况下共享</strong>：获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
          <li><strong className="font-semibold">在法定情形下共享</strong>：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</li>
          <li><strong className="font-semibold">与授权合作伙伴共享</strong>：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们会与合作伙伴签署严格的保密协定，要求其按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。</li>
        </ol>
        <p className="mt-3 leading-7 text-sm md:text-base">目前我们的授权合作伙伴包括：</p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li><strong className="font-semibold">云计算与存储服务商</strong>：为我们提供服务器、对象存储与内容分发服务，用于存储您的录音、转写文稿与账号数据；</li>
          <li><strong className="font-semibold">AI 语音识别与大语言模型服务商</strong>：为我们提供语音转写与内容总结的技术能力；</li>
          <li><strong className="font-semibold">统计分析、消息推送与崩溃上报服务商</strong>：见"第三部分 第三方 SDK 清单"；</li>
          <li><strong className="font-semibold">短信服务商</strong>：向您发送登录与验证短信。</li>
        </ul>

        <h3 className="mt-6 text-base font-semibold">2. 转让</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
        <ol className="mt-3 space-y-2 text-sm md:text-base list-decimal pl-5">
          <li>在获取明确同意的情况下转让；</li>
          <li>在涉及合并、收购或破产清算时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>
        </ol>

        <h3 className="mt-6 text-base font-semibold">3. 公开披露</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">我们仅会在以下情况下公开披露您的个人信息：</p>
        <ol className="mt-3 space-y-2 text-sm md:text-base list-decimal pl-5">
          <li>获得您明确同意后；</li>
          <li>基于法律或合理依据的公开披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">第五部分　我们如何存储您的个人信息</h2>

        <h3 className="mt-6 text-base font-semibold">1. 存储地域</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">我们在中华人民共和国境内收集和产生的个人信息，均存储于中华人民共和国境内的服务器，包括您的账号信息、录音音频文件、语音转写文稿、AI 总结内容、人物档案与声纹特征信息。</strong>
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">我们不会将上述个人信息向中华人民共和国境外提供。</strong>如未来因业务需要确需向境外提供个人信息，我们将依法向您告知境外接收方的名称、联系方式、处理目的与处理方式、个人信息种类，以及您向境外接收方行使权利的方式，取得您的<strong className="font-semibold">单独同意</strong>，并按照法律法规要求完成安全评估、认证或订立标准合同等程序。
        </p>

        <h3 className="mt-6 text-base font-semibold">2. 存储期限</h3>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li><strong className="font-semibold">账号信息</strong>：在您使用服务期间持续保存；您注销账号后，我们将删除或匿名化处理。</li>
          <li><strong className="font-semibold">录音音频、转写文稿与 AI 总结</strong>：在您主动删除或注销账号前持续保存，以便您随时查阅。您删除后，我们将在合理期限内从生产系统与备份中清除。</li>
          <li><strong className="font-semibold">声纹特征信息</strong>：在您删除对应声纹或注销账号后即时删除。</li>
          <li><strong className="font-semibold">日志与崩溃信息</strong>：一般保存不超过 12 个月。</li>
          <li>法律法规对存储期限另有规定的，从其规定。</li>
        </ul>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">第六部分　我们如何保护您的个人信息</h2>
        <ol className="mt-3 space-y-2 text-sm md:text-base list-decimal pl-5">
          <li>我们采用符合业界标准的安全防护措施，包括建立合理的制度规范与安全技术，防止您的个人信息遭到未经授权的访问、修改、损坏或丢失。</li>
          <li>数据在传输过程中使用 TLS/SSL 加密；账号密码采用加密方式存储；对象存储采用限时授权（预签名 URL）访问，避免文件被公开访问。</li>
          <li>我们对可能接触到您个人信息的员工实行最小权限原则与权限审批，并签署保密协议。</li>
          <li>我们会定期开展安全评估与演练，并制定了个人信息安全事件应急预案。</li>
          <li><strong className="font-semibold">请您理解，互联网并非绝对安全的环境。若不幸发生个人信息安全事件，我们将按照法律法规要求，及时以推送通知、邮件、公告等方式向您告知事件情况、我们已采取的处置措施与您可采取的补救建议，并按规定向监管部门报告。</strong></li>
          <li><strong className="font-semibold">请您妥善保管账号与密码，不要向任何第三方透露验证码。</strong></li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">第七部分　您的权利</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">按照中国相关法律法规，我们保障您对个人信息行使以下权利：</p>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full border-collapse text-sm md:text-base">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">权利</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">行使方式</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">查阅、复制</strong></td>
                <td className="border border-gray-200 px-3 py-2">在应用内"我的—个人资料"查阅账号信息，在记录列表查阅您的录音与转写内容；如需获取个人信息副本，可发送邮件至 service02@newtranx.com</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">更正、补充</strong></td>
                <td className="border border-gray-200 px-3 py-2">在应用内直接编辑个人资料、记录标题、转写文稿、人物档案等</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">删除</strong></td>
                <td className="border border-gray-200 px-3 py-2">在应用内删除单条或全部录音记录、AI 总结、人物档案与声纹；也可通过邮件申请删除</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">撤回同意</strong></td>
                <td className="border border-gray-200 px-3 py-2">在手机系统设置中关闭对应权限；或发送邮件至 service02@newtranx.com 撤回对本政策的同意（撤回后我们将停止相应处理，但不影响撤回前基于同意已进行的处理）</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">注销账号</strong></td>
                <td className="border border-gray-200 px-3 py-2">见下方"账号注销"说明</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">个人信息可携带</strong></td>
                <td className="border border-gray-200 px-3 py-2">如需将您的个人信息转移至其他个人信息处理者，可发送邮件申请，符合法定条件的我们将提供转移途径</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">获得解释说明</strong></td>
                <td className="border border-gray-200 px-3 py-2">对本政策及个人信息处理规则有疑问的，可发送邮件要求我们作出解释说明</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><strong className="font-semibold">已故者近亲属权利</strong></td>
                <td className="border border-gray-200 px-3 py-2">自然人死亡的，其近亲属为自身合法、正当利益，可对死者的相关个人信息行使查阅、复制、更正、删除等权利（死者生前另有安排的除外）</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="mt-6 text-base font-semibold">账号注销</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          如您需要注销 MossAura 账号，可向 <strong className="font-semibold">service02@newtranx.com</strong> 发送邮件，邮件主题注明"MossAura 账号注销"，并在邮件中提供需要注销的账号以及完成身份核验所必需的信息。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们将在收到申请后 <strong className="font-semibold">15 个工作日</strong>内完成核验与处理。<strong className="font-semibold">账号注销后，我们将删除或匿名化处理与该账号相关的个人信息（包括录音、转写文稿、AI 总结与声纹信息），法律法规另有规定的除外。账号注销不可恢复，请您谨慎操作。</strong>
        </p>

        <h3 className="mt-6 text-base font-semibold">响应期限</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          对于您的上述请求，我们将在 <strong className="font-semibold">15 个工作日</strong>内作出答复。如您对我们的答复不满意，还可以通过第九部分的联系方式进行投诉。
        </p>

        <h3 className="mt-6 text-base font-semibold">自动化决策说明</h3>
        <p className="mt-3 leading-7 text-sm md:text-base">
          MossAura 使用 AI 模型对您的录音内容进行转写与总结，属于自动化处理。<strong className="font-semibold">该处理仅用于向您本人展示内容整理结果，不会对您的权益产生重大影响，也不用于商业营销或信息推送的个性化决策。</strong>
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">第八部分　我们如何处理未成年人的个人信息</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">MossAura 主要面向成年人。若您是未满 16 岁的未成年人，请您在监护人的陪同下阅读本政策，并在事先取得家长或其法定监护人（以下统称"监护人"）可经查证的同意后，方可使用我们的服务、提交个人信息。监护人应承担保护未成年人在网络环境下隐私权的首要责任。</strong>
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          <strong className="font-semibold">根据《中华人民共和国个人信息保护法》，不满 14 周岁未成年人的个人信息属于敏感个人信息。我们处理不满 14 周岁未成年人的个人信息时，将取得其监护人的单独同意，并遵守更为严格的保护规则。</strong>
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们仅在法律允许、监护人明确同意或保护未成年人所必要的情况下收集、使用、共享或披露未成年人的个人信息。我们建立并维持合理的程序，以保护未成年人个人信息的保密性及安全性。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">经监护人同意后，我们向监护人提供：</p>
        <ol className="mt-3 space-y-2 text-sm md:text-base list-decimal pl-5">
          <li>审阅其子女或被监护人的个人信息的机会；</li>
          <li>拒绝其子女或被监护人的个人信息被进一步收集或使用的机会；</li>
          <li>变更或删除其子女或被监护人个人信息的方式；</li>
          <li>拒绝我们与其子女或被监护人做进一步联络的权利。</li>
        </ol>
        <p className="mt-3 leading-7 text-sm md:text-base">
          若我们发现在未事先获得可经查证的监护人同意的情况下收集了未成年人的个人信息，我们会设法尽快删除相关数据。若监护人发现我们在未获同意的情况下收集了未成年人的个人信息，请通过 <strong className="font-semibold">service02@newtranx.com</strong> 与我们联系，我们将及时处理。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">第九部分　本政策如何更新</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们可能适时修订本政策内容。未经您明确同意，我们不会削减您依据本政策所应享有的权利。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          对于重大变更，我们会通过应用内弹窗、推送通知或显著位置公告等方式另行告知，并在必要时重新征求您的同意。重大变更包括但不限于：
        </p>
        <ol className="mt-3 space-y-2 text-sm md:text-base list-decimal pl-5">
          <li>我们的服务模式发生重大变化，如处理个人信息的目的、类型、使用方式发生变化；</li>
          <li>我们在所有权结构、组织架构等方面发生重大变化，如业务调整、破产并购引起的所有者变更；</li>
          <li>个人信息共享、转让或公开披露的主要对象发生变化；</li>
          <li>您参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
          <li>我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</li>
          <li>个人信息安全影响评估报告表明存在高风险。</li>
        </ol>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们会在本页面发布对本政策所做的任何变更，并更新页首的版本号与生效日期。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">第十部分　如何联系我们</h2>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full border-collapse text-sm md:text-base">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">事项</th>
                <th className="border border-gray-200 px-3 py-2 text-left font-semibold">联系方式</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-200 px-3 py-2">运营者名称</td>
                <td className="border border-gray-200 px-3 py-2">新译信息科技（深圳）有限公司</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">个人信息保护负责人邮箱</td>
                <td className="border border-gray-200 px-3 py-2">service02@newtranx.com</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">用户咨询与投诉</td>
                <td className="border border-gray-200 px-3 py-2">service02@newtranx.com（邮件主题请注明"隐私"）</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2">响应时限</td>
                <td className="border border-gray-200 px-3 py-2">15 个工作日内</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-3 leading-7 text-sm md:text-base">
          如您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及市场监管等监管部门进行投诉或举报，或向有管辖权的人民法院提起诉讼。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">附录　名词解释</h2>
        <ul className="mt-3 space-y-3 text-sm md:text-base list-disc pl-5">
          <li><strong className="font-semibold">个人信息</strong>：以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</li>
          <li><strong className="font-semibold">敏感个人信息</strong>：一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。<strong className="font-semibold">本应用涉及的敏感个人信息为：声纹特征信息。我们仅在获得您的单独同意后处理，您也可随时删除已注册的声纹予以撤回。</strong></li>
          <li><strong className="font-semibold">去标识化</strong>：个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</li>
          <li><strong className="font-semibold">匿名化</strong>：个人信息经过处理无法识别特定自然人且不能复原的过程。</li>
          <li><strong className="font-semibold">Android_ID</strong>：Android 系统为每台设备生成的标识符，用于设备识别与统计去重。</li>
          <li><strong className="font-semibold">OAID</strong>：移动智能终端补充设备标识体系提供的匿名设备标识符，可由用户在系统设置中重置或关闭。</li>
          <li><strong className="font-semibold">剪贴板</strong>：操作系统提供的、用于在应用之间传递文本等内容的临时存储区域。</li>
        </ul>
      </section>
    </div>
  );
}

export default PrivacyPolicyPage;
